

export const SignInContent = [
    {
        img: "./assets/vogue-img.jpg",
    }
]

export const HeroImages = [
    {
        id: 1,
        image: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
        text: 'DISCOVER YOUR PERFECT STYLE',
        subHead: 'Fashion',
        subText: 'Unleash Your Fashion Potential with Our Exclusive Collection',

    },
    {
        id: 2,
        image: 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
        text: 'Discover a World of Fashion',
        subHead: 'Fall Fashion',
        subText: 'Embrace the changing seasons with our cozy collection',
    },
    {
        id: 3,
        image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80',
        text: 'Get the Best Deals on Fashion',
        subHead: 'New Arrivals',
        subText: 'Shop now to stay ahead in fashion!',
    },
    {
        id: 4,
        image: 'https://images.unsplash.com/photo-1591085686350-798c0f9faa7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1031&q=80',
        text: 'Stay safe and glowing this summer',
        subHead: 'Trendsetter\'s Choice',
        subText: 'Show off your unique style and set the trend for others',
    },
    {
        id: 5,
        image: 'https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80',
        text: 'Shop from the Comfort of Your Home',
        subHead: 'Luxe Collection',
        subText: 'Elevate your elegance and make every moment special',
    }
]

export const topClothes = [
    {
        "id": 1,
        "image": "./assets/basicshirt.jpg",
        "altImage": "basic t-shirt",
        "category": "t-shirt",
        "gender": "couple",
        "shirtName": "Basic T-Shirt",
        "description": "Lorem ipsum dolor sit amet consectetur. Dictumst nulla duis condimentum morbi gravida mattis suspendisse. Quis purus eget eros dolor turpis mi dictum sed. Facilisi dignissim dolor odio imperdiet morbi. Neque dolor lobortis bibendum euismod lobortis turpis facilisi sem at.",
        "prodPrice": "₱499",
        "likes": 0
    },
    {
        "id": 2,
        "image": "./assets/basicjacket.jpg",
        "altImage": "basic t-shirt",
        "category": "Jacket",
        "gender": "womens",
        "shirtName": "Basic Jacket",
        "description": "Lorem ipsum dolor sit amet consectetur. Dictumst nulla duis condimentum morbi gravida mattis suspendisse. Quis purus eget eros dolor turpis mi dictum sed. Facilisi dignissim dolor odio imperdiet morbi. Neque dolor lobortis bibendum euismod lobortis turpis facilisi sem at.",
        "prodPrice": "₱599",
        "likes": 0
    },
    {
        "id": 3,
        "image": "./assets/basicpants.jpg",
        "altImage": "basic t-shirt",
        "category": "t-shirt",
        "gender": "mens",
        "shirtName": "Basic T-Shirt",
        "description": "Lorem ipsum dolor sit amet consectetur. Dictumst nulla duis condimentum morbi gravida mattis suspendisse. Quis purus eget eros dolor turpis mi dictum sed. Facilisi dignissim dolor odio imperdiet morbi. Neque dolor lobortis bibendum euismod lobortis turpis facilisi sem at.",
        "prodPrice": "₱499",
        "likes": 0
    },
]


    export const products =  [
            {
                "articleCode": "1168445001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1168445001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE2ODQ0NV9ncm91cF8wMDFfZW5fYXNpYTU7MTE2ODQ0NTAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1168445001');",
                "link": "/en_asia5/productpage.1168445001.html",
                "title": "DryMove™ Sports joggers",
                "category": "men_sport_bottoms_trousers",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/eb/2a/eb2a91fd0c1ad1d196531f252fdb47ddccc2628e.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/19/35/193510126ff341963de82d4562d217bda52d8119.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "DryMove™ Sports joggers Model",
                        "dataAltText": "DryMove™ Sports joggers"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1168445001|DryMove™ Sports joggers|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,690",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1168445001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#615D5E",
                        "articleLink": "/en_asia5/productpage.1168445002.html",
                        "colorName": "Dark grey"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1183921002",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1183921002'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE4MzkyMV9ncm91cF8wMDJfZW5fYXNpYTU7MTE4MzkyMTAwMl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1183921002');",
                "link": "/en_asia5/productpage.1183921002.html",
                "title": "Lightweight puffer jacket",
                "category": "men_jacketscoats_jackets",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/98/d2/98d225f356401d09a97add9d077d58054c644c2c.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/d5/f8/d5f8310425b85de71c4525d457f0be973be26d99.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Lightweight puffer jacket Model",
                        "dataAltText": "Lightweight puffer jacket"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1183921002|Lightweight puffer jacket|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#9F9E99",
                        "articleLink": "/en_asia5/productpage.1183921002.html",
                        "colorName": "Light grey"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1183921001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#3C4434",
                        "articleLink": "/en_asia5/productpage.1183921003.html",
                        "colorName": "Dark green"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1166941002",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1166941002'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE2Njk0MV9ncm91cF8wMDJfZW5fYXNpYTU7MTE2Njk0MTAwMl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1166941002');",
                "link": "/en_asia5/productpage.1166941002.html",
                "title": "Relaxed Fit Flannel shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/a9/9c/a99c41c97e2d03851757af65ff9fd38b92d65dce.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/6b/ec/6becf84f5c26f3573a4dfc177db2fc4d0990ddcc.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Flannel shirt Model",
                        "dataAltText": "Relaxed Fit Flannel shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1166941002|Relaxed Fit Flannel shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#B91623",
                        "articleLink": "/en_asia5/productpage.1166941002.html",
                        "colorName": "Red/Checked"
                    },
                    {
                        "colorCode": "#EDEEE6",
                        "articleLink": "/en_asia5/productpage.1166941001.html",
                        "colorName": "Black/Checked"
                    },
                    {
                        "colorCode": "#504F53",
                        "articleLink": "/en_asia5/productpage.1166941005.html",
                        "colorName": "Dark grey/Checked"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0972640066",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0972640066'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDk3MjY0MF9ncm91cF8wNjZfZW5fYXNpYTU7MDk3MjY0MDA2Nl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0972640066');",
                "link": "/en_asia5/productpage.0972640066.html",
                "title": "Relaxed Fit T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/31/32/3132d20504ae36fdf82d15e1530e0e52391ed737.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/ff/39/ff39ec1510e4c6c71d5f9657223898fe5d3e1982.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit T-shirt Model",
                        "dataAltText": "Relaxed Fit T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0972640066|Relaxed Fit T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP899",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0972640066.html",
                        "colorName": "Black/Wednesday"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.0972640062.html",
                        "colorName": "White/The Discovery Channel"
                    },
                    {
                        "colorCode": "#A9A39B",
                        "articleLink": "/en_asia5/productpage.0972640063.html",
                        "colorName": "Beige/Kodak"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1174601003",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1174601003'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE3NDYwMV9ncm91cF8wMDNfZW5fYXNpYTU7MTE3NDYwMTAwM19lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1174601003');",
                "link": "/en_asia5/productpage.1174601003.html",
                "title": "Regular Fit Flannel shirt",
                "category": "men_shirts_longsleeved",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/d7/5c/d75cfef6acc1b0a92593f82d5184e78881127838.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/1e/ba/1eba8af51b3fcbf1f03f3b062423aac935cd0c2d.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Flannel shirt Model",
                        "dataAltText": "Regular Fit Flannel shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1174601003|Regular Fit Flannel shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#384440",
                        "articleLink": "/en_asia5/productpage.1174601003.html",
                        "colorName": "Dark green/Checked"
                    },
                    {
                        "colorCode": "#68513C",
                        "articleLink": "/en_asia5/productpage.1174601002.html",
                        "colorName": "Brown/Checked"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1166941005",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1166941005'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE2Njk0MV9ncm91cF8wMDVfZW5fYXNpYTU7MTE2Njk0MTAwNV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1166941005');",
                "link": "/en_asia5/productpage.1166941005.html",
                "title": "Relaxed Fit Flannel shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/33/91/3391b7ff80f279d40c4fce044f55d2c5783ba985.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/6f/64/6f64c69af0b7e3358db10c2156bf52edd657aeb4.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Flannel shirt Model",
                        "dataAltText": "Relaxed Fit Flannel shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1166941005|Relaxed Fit Flannel shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#504F53",
                        "articleLink": "/en_asia5/productpage.1166941005.html",
                        "colorName": "Dark grey/Checked"
                    },
                    {
                        "colorCode": "#EDEEE6",
                        "articleLink": "/en_asia5/productpage.1166941001.html",
                        "colorName": "Black/Checked"
                    },
                    {
                        "colorCode": "#B91623",
                        "articleLink": "/en_asia5/productpage.1166941002.html",
                        "colorName": "Red/Checked"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0792944009",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0792944009'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDc5Mjk0NF9ncm91cF8wMDlfZW5fYXNpYTU7MDc5Mjk0NDAwOV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0792944009');",
                "link": "/en_asia5/productpage.0792944009.html",
                "title": "Long, hooded cardigan",
                "category": "men_hoodiessweatshirts_hoodies",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/e5/ef/e5efad01d9d7612715afa438909d2e5fedb467b7.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/7e/a1/7ea12298684fe882dd57801b746c868c7c07b8a5.jpg],origin[dam],category[men_hoodiessweatshirts_hoodies],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Long, hooded cardigan Model",
                        "dataAltText": "Long, hooded cardigan"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0792944009|Long, hooded cardigan|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,590",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#6C6D6E",
                        "articleLink": "/en_asia5/productpage.0792944009.html",
                        "colorName": "Dark grey"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0792944001.html",
                        "colorName": "Black"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0662369115",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0662369115'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDY2MjM2OV9ncm91cF8xMTVfZW5fYXNpYTU7MDY2MjM2OTExNV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0662369115');",
                "link": "/en_asia5/productpage.0662369115.html",
                "title": "3-pack woven cotton boxer shorts",
                "category": "men_underwear_boxers",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/17/0b/170b7bca895c60c82a4a1457626caf44e513208c.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/0e/5b/0e5bd54c54cd57da92c1ae5e847f363120f64c28.jpg],origin[dam],category[men_underwear_boxers],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "3-pack woven cotton boxer shorts Model",
                        "dataAltText": "3-pack woven cotton boxer shorts"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0662369115|3-pack woven cotton boxer shorts|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,190",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#222D47",
                        "articleLink": "/en_asia5/productpage.0662369115.html",
                        "colorName": "Blue/Striped"
                    },
                    {
                        "colorCode": "#4D4D4B",
                        "articleLink": "/en_asia5/productpage.0662369119.html",
                        "colorName": "Dark grey/Light purple"
                    },
                    {
                        "colorCode": "#AABCDC",
                        "articleLink": "/en_asia5/productpage.0662369120.html",
                        "colorName": "Light blue/Checked"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1160969001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1160969001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE2MDk2OV9ncm91cF8wMDFfZW5fYXNpYTU7MTE2MDk2OTAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1160969001');",
                "link": "/en_asia5/productpage.1160969001.html",
                "title": "Regular Fit Windbreaker",
                "category": "men_jacketscoats_function",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/10/06/1006785bd3a382e05e2f923976023e9e10b25c20.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/cb/58/cb58e4cfa60c61919eb55b342624515af6dc607a.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Windbreaker Model",
                        "dataAltText": "Regular Fit Windbreaker"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1160969001|Regular Fit Windbreaker|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1160969001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#E3E4DF",
                        "articleLink": "/en_asia5/productpage.1160969002.html",
                        "colorName": "Cream"
                    },
                    {
                        "colorCode": "#C97542",
                        "articleLink": "/en_asia5/productpage.1160969003.html",
                        "colorName": "Orange"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1074402008",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1074402008'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTA3NDQwMl9ncm91cF8wMDhfZW5fYXNpYTU7MTA3NDQwMjAwOF9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1074402008');",
                "link": "/en_asia5/productpage.1074402008.html",
                "title": "Slim Fit Cotton twill trousers",
                "category": "men_trousers",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/3c/97/3c9777dff98444f57df03cdb1a30db2f648a43b9.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/ee/be/eebe9270965f6d47cf875961ce6a73764393d5f5.jpg],origin[dam],category[men_trousers],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Slim Fit Cotton twill trousers Model",
                        "dataAltText": "Slim Fit Cotton twill trousers"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1074402008|Slim Fit Cotton twill trousers|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,190",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "5",
                "swatches": [
                    {
                        "colorCode": "#BFC2C1",
                        "articleLink": "/en_asia5/productpage.1074402008.html",
                        "colorName": "Light grey"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1074402001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#393A45",
                        "articleLink": "/en_asia5/productpage.1074402002.html",
                        "colorName": "Navy blue"
                    },
                    {
                        "colorCode": "#383A3D",
                        "articleLink": "/en_asia5/productpage.1074402003.html",
                        "colorName": "Dark grey"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1197143001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1197143001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE5NzE0M19ncm91cF8wMDFfZW5fYXNpYTU7MTE5NzE0MzAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1197143001');",
                "link": "/en_asia5/productpage.1197143001.html",
                "title": "Oversized Fit Printed hoodie",
                "category": "men_hoodiessweatshirts_hoodies",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/af/8e/af8eeeac3929b4006f44a806be94bd20be8c6e7a.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/45/3c/453c441fbe70eb8bdfc94e62d7f17d6473538453.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Oversized Fit Printed hoodie Model",
                        "dataAltText": "Oversized Fit Printed hoodie"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1197143001|Oversized Fit Printed hoodie|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP2,490",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1197143001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#D6322C",
                        "articleLink": "/en_asia5/productpage.1197143002.html",
                        "colorName": "Red"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1003662046",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1003662046'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAwMzY2Ml9ncm91cF8wNDZfZW5fYXNpYTU7MTAwMzY2MjA0Nl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1003662046');",
                "link": "/en_asia5/productpage.1003662046.html",
                "title": "Relaxed Fit T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/41/b6/41b647513905e3cea38d1c108451032ac5b33f47.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/49/df/49dff37b9c58facbbb0a86190d2ac08bae87aff9.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit T-shirt Model",
                        "dataAltText": "Relaxed Fit T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1003662046|Relaxed Fit T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP499",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "5",
                "swatches": [
                    {
                        "colorCode": "#C0BED1",
                        "articleLink": "/en_asia5/productpage.1003662046.html",
                        "colorName": "Light purple/Striped"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.1003662001.html",
                        "colorName": "White"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1003662002.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#C0BBAD",
                        "articleLink": "/en_asia5/productpage.1003662012.html",
                        "colorName": "Light beige"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0714032047",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0714032047'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDcxNDAzMl9ncm91cF8wNDdfZW5fYXNpYTU7MDcxNDAzMjA0N19lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0714032047');",
                "link": "/en_asia5/productpage.0714032047.html",
                "title": "Skinny Fit Suit trousers",
                "category": "men_trousers_trousers_skinny_all",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/9d/91/9d91035b20bbbb88f8d85cb52416d3ff9fd49d21.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/06/51/06515a5d801e8b7340196d68442589674acc26f1.jpg],origin[dam],category[men_trousers_trousers_skinny_all],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Skinny Fit Suit trousers Model",
                        "dataAltText": "Skinny Fit Suit trousers"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0714032047|Skinny Fit Suit trousers|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "7",
                "swatches": [
                    {
                        "colorCode": "#330F1A",
                        "articleLink": "/en_asia5/productpage.0714032047.html",
                        "colorName": "Burgundy"
                    },
                    {
                        "colorCode": "#330F1A",
                        "articleLink": "/en_asia5/productpage.0714032013.html",
                        "colorName": "Burgundy"
                    },
                    {
                        "colorCode": "#62615E",
                        "articleLink": "/en_asia5/productpage.0714032024.html",
                        "colorName": "Grey"
                    },
                    {
                        "colorCode": "#877F75",
                        "articleLink": "/en_asia5/productpage.0714032035.html",
                        "colorName": "Beige marl"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0652360029",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0652360029'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDY1MjM2MF9ncm91cF8wMjlfZW5fYXNpYTU7MDY1MjM2MDAyOV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0652360029');",
                "link": "/en_asia5/productpage.0652360029.html",
                "title": "3-pack woven cotton boxer shorts",
                "category": "men_underwear_boxers",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/53/17/531784ee7ecdc3ad632c09559022391f0aa8746d.jpg],origin[dam],category[men_underwear_boxers],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/53/17/531784ee7ecdc3ad632c09559022391f0aa8746d.jpg],origin[dam],category[men_underwear_boxers],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "3-pack woven cotton boxer shorts Model",
                        "dataAltText": "3-pack woven cotton boxer shorts"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0652360029|3-pack woven cotton boxer shorts|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "Disney100 x H&M",
                "marketingMarkerType": "marker-collection",
                "marketingMarkerCss": "",
                "price": "PHP1,190",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#473A59",
                        "articleLink": "/en_asia5/productpage.0652360029.html",
                        "colorName": "Dark purple/Disney100"
                    },
                    {
                        "colorCode": "#0E00A5",
                        "articleLink": "/en_asia5/productpage.0652360024.html",
                        "colorName": "Bright blue/Avengers"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0970819062",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0970819062'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDk3MDgxOV9ncm91cF8wNjJfZW5fYXNpYTU7MDk3MDgxOTA2Ml9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0970819062');",
                "link": "/en_asia5/productpage.0970819062.html",
                "title": "Relaxed Fit Hoodie",
                "category": "men_hoodiessweatshirts_hoodies",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/35/26/35269ddf80ba5ce2c77de3129835bccad52f8f44.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/ce/b2/ceb23d4ac9046679d205550e77cb8d97839ed257.jpg],origin[dam],category[men_hoodiessweatshirts_hoodies],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Hoodie Model",
                        "dataAltText": "Relaxed Fit Hoodie"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0970819062|Relaxed Fit Hoodie|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP999",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "13",
                "swatches": [
                    {
                        "colorCode": "#96A9A4",
                        "articleLink": "/en_asia5/productpage.0970819062.html",
                        "colorName": "Turquoise"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0970819001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.0970819002.html",
                        "colorName": "White"
                    },
                    {
                        "colorCode": "#AFAFAF",
                        "articleLink": "/en_asia5/productpage.0970819007.html",
                        "colorName": "Light grey marl"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0970818060",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0970818060'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDk3MDgxOF9ncm91cF8wNjBfZW5fYXNpYTU7MDk3MDgxODA2MF9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0970818060');",
                "link": "/en_asia5/productpage.0970818060.html",
                "title": "Relaxed Fit Sweatshirt",
                "category": "men_hoodiessweatshirts_sweatshirts",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/34/a6/34a677e1bea2c626e5721d60058b7d273263ca7b.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/52/03/5203cedea54aff7226eda6a2740e3805904b1f32.jpg],origin[dam],category[men_hoodiessweatshirts_sweatshirts],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Sweatshirt Model",
                        "dataAltText": "Relaxed Fit Sweatshirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0970818060|Relaxed Fit Sweatshirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP899",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "11",
                "swatches": [
                    {
                        "colorCode": "#F9CFE0",
                        "articleLink": "/en_asia5/productpage.0970818060.html",
                        "colorName": "Pink"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0970818001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#AFAFAF",
                        "articleLink": "/en_asia5/productpage.0970818002.html",
                        "colorName": "Light grey marl"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.0970818003.html",
                        "colorName": "White"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1206081001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1206081001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTIwNjA4MV9ncm91cF8wMDFfZW5fYXNpYTU7MTIwNjA4MTAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1206081001');",
                "link": "/en_asia5/productpage.1206081001.html",
                "title": "Regular Fit Textured-knit resort shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/43/35/4335cb1a81ab04e2a5d0bf0c8ff7ca30809f2de6.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/29/33/2933bfc4fc55f496204759d204b59167d7912eb0.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Textured-knit resort shirt Model",
                        "dataAltText": "Regular Fit Textured-knit resort shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1206081001|Regular Fit Textured-knit resort shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "1",
                "swatches": [
                    {
                        "colorCode": "#856D5E",
                        "articleLink": "/en_asia5/productpage.1206081001.html",
                        "colorName": "Light brown/Striped"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1195461001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1195461001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE5NTQ2MV9ncm91cF8wMDFfZW5fYXNpYTU7MTE5NTQ2MTAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1195461001');",
                "link": "/en_asia5/productpage.1195461001.html",
                "title": "Regular Fit Long-sleeved polo shirt",
                "category": "MEN_TSHIRTSTANKS_POLO",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/d5/00/d5004024679b25c415fcddbbf096b04771486fb3.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/3a/3b/3a3b381bd1215e821d2a2e676db863a96e854a28.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Long-sleeved polo shirt Model",
                        "dataAltText": "Regular Fit Long-sleeved polo shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1195461001|Regular Fit Long-sleeved polo shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,690",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "1",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1195461001.html",
                        "colorName": "Black/Wednesday"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1025664007",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1025664007'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAyNTY2NF9ncm91cF8wMDdfZW5fYXNpYTU7MTAyNTY2NDAwN19lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1025664007');",
                "link": "/en_asia5/productpage.1025664007.html",
                "title": "COOLMAX® Regular Fit Shirt",
                "category": "men_shirts_longsleeved",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/55/b1/55b11158671c467165579896ab28de35bd905409.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/c2/32/c23248d3be238be416251b49bc607bcfb0db28b1.jpg],origin[dam],category[men_shirts_longsleeved],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "COOLMAX® Regular Fit Shirt Model",
                        "dataAltText": "COOLMAX® Regular Fit Shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1025664007|COOLMAX® Regular Fit Shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,690",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "4",
                "swatches": [
                    {
                        "colorCode": "#4A473E",
                        "articleLink": "/en_asia5/productpage.1025664007.html",
                        "colorName": "Khaki green"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.1025664001.html",
                        "colorName": "White"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1025664002.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1025664008.html",
                        "colorName": "Dark blue/Striped"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1140854005",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1140854005'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE0MDg1NF9ncm91cF8wMDVfZW5fYXNpYTU7MTE0MDg1NDAwNV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1140854005');",
                "link": "/en_asia5/productpage.1140854005.html",
                "title": "Oversized Fit Printed mesh T-shirt",
                "category": "men_tshirtstanks_printed",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/c0/d3/c0d3efc4a525802470966459631c0ca241ddf59e.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/12/7e/127e7d10d658a3e789f0ba4ff73d984b0582138e.jpg],origin[dam],category[men_tshirtstanks_printed],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Oversized Fit Printed mesh T-shirt Model",
                        "dataAltText": "Oversized Fit Printed mesh T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1140854005|Oversized Fit Printed mesh T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP999",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1140854005.html",
                        "colorName": "Black/New York City 83"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1140854004.html",
                        "colorName": "Black/New York"
                    },
                    {
                        "colorCode": "#344F87",
                        "articleLink": "/en_asia5/productpage.1140854007.html",
                        "colorName": "Blue/Miami"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1158018004",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1158018004'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE1ODAxOF9ncm91cF8wMDRfZW5fYXNpYTU7MTE1ODAxODAwNF9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1158018004');",
                "link": "/en_asia5/productpage.1158018004.html",
                "title": "DryMove™ Printed sports T-shirt",
                "category": "sportswear_men_activity_training_tops",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/4b/08/4b084b67346935f120a5f1cacf84f0c73a5f4425.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/2c/48/2c48b193020afbf3e0879322e88ec5249fb67bd4.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "DryMove™ Printed sports T-shirt Model",
                        "dataAltText": "DryMove™ Printed sports T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1158018004|DryMove™ Printed sports T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP899",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#898D8B",
                        "articleLink": "/en_asia5/productpage.1158018004.html",
                        "colorName": "Grey/Cardio"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1158018002.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1158018009.html",
                        "colorName": "Black"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1208681004",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1208681004'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTIwODY4MV9ncm91cF8wMDRfZW5fYXNpYTU7MTIwODY4MTAwNF9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1208681004');",
                "link": "/en_asia5/productpage.1208681004.html",
                "title": "Regular Fit Hole-knit polo shirt",
                "category": "MEN_TSHIRTSTANKS_POLO",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/2e/df/2edfddf222a4754126e23763bf40dc290ea16e1d.jpg],origin[dam],category[MEN_TSHIRTSTANKS_POLO],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/2e/df/2edfddf222a4754126e23763bf40dc290ea16e1d.jpg],origin[dam],category[MEN_TSHIRTSTANKS_POLO],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Hole-knit polo shirt Model",
                        "dataAltText": "Regular Fit Hole-knit polo shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1208681004|Regular Fit Hole-knit polo shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,590",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#B8BD99",
                        "articleLink": "/en_asia5/productpage.1208681004.html",
                        "colorName": "Pistachio green"
                    },
                    {
                        "colorCode": "#EEEDE4",
                        "articleLink": "/en_asia5/productpage.1208681003.html",
                        "colorName": "Cream"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1035207026",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1035207026'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAzNTIwN19ncm91cF8wMjZfZW5fYXNpYTU7MTAzNTIwNzAyNl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1035207026');",
                "link": "/en_asia5/productpage.1035207026.html",
                "title": "Oversized Fit Cotton T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/7e/7f/7e7fe82541491ac535f2ac76ab78638e8aec4f72.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/14/73/1473405f7bf7aa1a0afb49f428a1593ac2db6af1.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Oversized Fit Cotton T-shirt Model",
                        "dataAltText": "Oversized Fit Cotton T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1035207026|Oversized Fit Cotton T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP899",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "7",
                "swatches": [
                    {
                        "colorCode": "#C3BEB7",
                        "articleLink": "/en_asia5/productpage.1035207026.html",
                        "colorName": "Light beige"
                    },
                    {
                        "colorCode": "#363638",
                        "articleLink": "/en_asia5/productpage.1035207008.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#0F433E",
                        "articleLink": "/en_asia5/productpage.1035207014.html",
                        "colorName": "Forest green"
                    },
                    {
                        "colorCode": "#EEEDE4",
                        "articleLink": "/en_asia5/productpage.1035207018.html",
                        "colorName": "Off-white"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1166941001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1166941001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTE2Njk0MV9ncm91cF8wMDFfZW5fYXNpYTU7MTE2Njk0MTAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1166941001');",
                "link": "/en_asia5/productpage.1166941001.html",
                "title": "Relaxed Fit Flannel shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/e5/bc/e5bc61f451f602b4795e4b311d746c75d7baf22e.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/f3/c2/f3c2e015e79873e63751e0bb62332b6c74a9601e.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Flannel shirt Model",
                        "dataAltText": "Relaxed Fit Flannel shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1166941001|Relaxed Fit Flannel shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#EDEEE6",
                        "articleLink": "/en_asia5/productpage.1166941001.html",
                        "colorName": "Black/Checked"
                    },
                    {
                        "colorCode": "#B91623",
                        "articleLink": "/en_asia5/productpage.1166941002.html",
                        "colorName": "Red/Checked"
                    },
                    {
                        "colorCode": "#504F53",
                        "articleLink": "/en_asia5/productpage.1166941005.html",
                        "colorName": "Dark grey/Checked"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1024256011",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1024256011'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAyNDI1Nl9ncm91cF8wMTFfZW5fYXNpYTU7MTAyNDI1NjAxMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1024256011');",
                "link": "/en_asia5/productpage.1024256011.html",
                "title": "Slim Jeans",
                "category": "men_jeans_slim",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/b4/16/b416c3b8e3006eec5632e4c525f4e355efbf07a3.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/d9/88/d988936520622d511be5d9d155570e7974294ef2.jpg],origin[dam],category[men_jeans_slim],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Slim Jeans Model",
                        "dataAltText": "Slim Jeans"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1024256011|Slim Jeans|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "6",
                "swatches": [
                    {
                        "colorCode": "#8898AC",
                        "articleLink": "/en_asia5/productpage.1024256011.html",
                        "colorName": "Light denim blue"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1024256001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#6089C2",
                        "articleLink": "/en_asia5/productpage.1024256003.html",
                        "colorName": "Light denim blue"
                    },
                    {
                        "colorCode": "#2F323B",
                        "articleLink": "/en_asia5/productpage.1024256005.html",
                        "colorName": "Dark blue"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0973277052",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0973277052'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDk3MzI3N19ncm91cF8wNTJfZW5fYXNpYTU7MDk3MzI3NzA1Ml9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0973277052');",
                "link": "/en_asia5/productpage.0973277052.html",
                "title": "Regular Fit T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/0c/fb/0cfb7402567300e152b663184ef19427b793fbeb.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/bc/2d/bc2d37880c423305bdb2f77d57c62a114e929a00.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit T-shirt Model",
                        "dataAltText": "Regular Fit T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0973277052|Regular Fit T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP599",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "4",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0973277052.html",
                        "colorName": "Black/Formula 1"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0973277044.html",
                        "colorName": "Black/Nirvana"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.0973277046.html",
                        "colorName": "Black/The Rolling Stones"
                    },
                    {
                        "colorCode": "#EEECE0",
                        "articleLink": "/en_asia5/productpage.0973277049.html",
                        "colorName": "Cream/Snoopy"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1206084001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1206084001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTIwNjA4NF9ncm91cF8wMDFfZW5fYXNpYTU7MTIwNjA4NDAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1206084001');",
                "link": "/en_asia5/productpage.1206084001.html",
                "title": "Regular Fit Textured-weave resort shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/79/29/7929441f6f7ecf337f5b6cab660f08231e30e564.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/ac/86/ac86425c4388edbee1593771f449546bff879e4b.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Textured-weave resort shirt Model",
                        "dataAltText": "Regular Fit Textured-weave resort shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1206084001|Regular Fit Textured-weave resort shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "1",
                "swatches": [
                    {
                        "colorCode": "#AE9F8E",
                        "articleLink": "/en_asia5/productpage.1206084001.html",
                        "colorName": "Beige"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1206083001",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1206083001'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTIwNjA4M19ncm91cF8wMDFfZW5fYXNpYTU7MTIwNjA4MzAwMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1206083001');",
                "link": "/en_asia5/productpage.1206083001.html",
                "title": "Regular Fit Resort shirt",
                "category": "men_shirts_casual",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/73/8b/738b0e066a85d3fa732c0febac83d78accba4f53.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/f4/fa/f4fa569c9ccec83a855be4e547809d27113349bc.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Resort shirt Model",
                        "dataAltText": "Regular Fit Resort shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1206083001|Regular Fit Resort shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,990",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "1",
                "swatches": [
                    {
                        "colorCode": "#F0EFEC",
                        "articleLink": "/en_asia5/productpage.1206083001.html",
                        "colorName": "Light beige/Striped"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1003662012",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1003662012'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAwMzY2Ml9ncm91cF8wMTJfZW5fYXNpYTU7MTAwMzY2MjAxMl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1003662012');",
                "link": "/en_asia5/productpage.1003662012.html",
                "title": "Relaxed Fit T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/19/e3/19e325ec23c4e77b9b1afc68ae055c48d1f6df02.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/74/7c/747c05e98d8e3196d2ac619d99e250be4c32ee6a.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit T-shirt Model",
                        "dataAltText": "Relaxed Fit T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1003662012|Relaxed Fit T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP499",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "5",
                "swatches": [
                    {
                        "colorCode": "#C0BBAD",
                        "articleLink": "/en_asia5/productpage.1003662012.html",
                        "colorName": "Light beige"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.1003662001.html",
                        "colorName": "White"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1003662002.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#C8C8C8",
                        "articleLink": "/en_asia5/productpage.1003662026.html",
                        "colorName": "Light grey marl"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1070268010",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1070268010'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTA3MDI2OF9ncm91cF8wMTBfZW5fYXNpYTU7MTA3MDI2ODAxMF9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1070268010');",
                "link": "/en_asia5/productpage.1070268010.html",
                "title": "5-pack Xtra Life™ short trunks",
                "category": "men_underwear_trunks",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/cf/96/cf968c0a1f069f7a8b0a1223baf3cf3b3c6df550.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/8a/a5/8aa55f96da86ee511275ef3463e5e5211a269a72.jpg],origin[dam],category[men_underwear_trunks],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "5-pack Xtra Life™ short trunks Model",
                        "dataAltText": "5-pack Xtra Life™ short trunks"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1070268010|5-pack Xtra Life™ short trunks|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "5",
                "swatches": [
                    {
                        "colorCode": "#8C93A8",
                        "articleLink": "/en_asia5/productpage.1070268010.html",
                        "colorName": "Light blue/Dark blue"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1070268001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#FFFFFF",
                        "articleLink": "/en_asia5/productpage.1070268002.html",
                        "colorName": "White"
                    },
                    {
                        "colorCode": "#6A6B70",
                        "articleLink": "/en_asia5/productpage.1070268003.html",
                        "colorName": "Grey/Black"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1035207027",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1035207027'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAzNTIwN19ncm91cF8wMjdfZW5fYXNpYTU7MTAzNTIwNzAyN19lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1035207027');",
                "link": "/en_asia5/productpage.1035207027.html",
                "title": "Oversized Fit Cotton T-shirt",
                "category": "men_tshirtstanks_shortsleeve",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/87/ad/87ad5d859911db64b992321c2739eeaa13a67625.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/b3/08/b308a7966a17364985dbf052fdda8adcdf40109a.jpg],origin[dam],category[men_tshirtstanks_shortsleeve],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Oversized Fit Cotton T-shirt Model",
                        "dataAltText": "Oversized Fit Cotton T-shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1035207027|Oversized Fit Cotton T-shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP899",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "7",
                "swatches": [
                    {
                        "colorCode": "#6A5247",
                        "articleLink": "/en_asia5/productpage.1035207027.html",
                        "colorName": "Brown"
                    },
                    {
                        "colorCode": "#363638",
                        "articleLink": "/en_asia5/productpage.1035207008.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#0F433E",
                        "articleLink": "/en_asia5/productpage.1035207014.html",
                        "colorName": "Forest green"
                    },
                    {
                        "colorCode": "#EEEDE4",
                        "articleLink": "/en_asia5/productpage.1035207018.html",
                        "colorName": "Off-white"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1117747015",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1117747015'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTExNzc0N19ncm91cF8wMTVfZW5fYXNpYTU7MTExNzc0NzAxNV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1117747015');",
                "link": "/en_asia5/productpage.1117747015.html",
                "title": "Relaxed Fit Sweatshirt",
                "category": "men_hoodiessweatshirts_sweatshirts",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/b0/be/b0be121a512bbb8461873544231beb0f130a7fa4.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/cb/01/cb01d3837943a7cb9eb108cbdb7e8df7bddfa280.jpg],origin[dam],category[men_hoodiessweatshirts_sweatshirts],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Sweatshirt Model",
                        "dataAltText": "Relaxed Fit Sweatshirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1117747015|Relaxed Fit Sweatshirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,690",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1117747015.html",
                        "colorName": "Black/Keith Haring"
                    },
                    {
                        "colorCode": "#858C94",
                        "articleLink": "/en_asia5/productpage.1117747009.html",
                        "colorName": "Light grey marl/Snoopy"
                    },
                    {
                        "colorCode": "#F0F1F0",
                        "articleLink": "/en_asia5/productpage.1117747016.html",
                        "colorName": "White/Snoopy"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1208681003",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1208681003'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTIwODY4MV9ncm91cF8wMDNfZW5fYXNpYTU7MTIwODY4MTAwM19lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1208681003');",
                "link": "/en_asia5/productpage.1208681003.html",
                "title": "Regular Fit Hole-knit polo shirt",
                "category": "MEN_TSHIRTSTANKS_POLO",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/3a/58/3a5802cf6c2535d3c6c57002fad127777b4ba59e.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/95/73/957350a3f60e0271b69335eed417c834bec52cb9.jpg],origin[dam],category[],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Hole-knit polo shirt Model",
                        "dataAltText": "Regular Fit Hole-knit polo shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1208681003|Regular Fit Hole-knit polo shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,590",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "2",
                "swatches": [
                    {
                        "colorCode": "#EEEDE4",
                        "articleLink": "/en_asia5/productpage.1208681003.html",
                        "colorName": "Cream"
                    },
                    {
                        "colorCode": "#B8BD99",
                        "articleLink": "/en_asia5/productpage.1208681004.html",
                        "colorName": "Pistachio green"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "0827280021",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','0827280021'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MDgyNzI4MF9ncm91cF8wMjFfZW5fYXNpYTU7MDgyNzI4MDAyMV9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','0827280021');",
                "link": "/en_asia5/productpage.0827280021.html",
                "title": "Regular Fit Checked shirt",
                "category": "men_shirts_longsleeved",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/1c/37/1c37c9f9e8a644f08262376f042677627fde0681.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/09/2e/092ed902bfcd3bebffd75ae48b1dba50e8c6cfcc.jpg],origin[dam],category[men_shirts_longsleeved],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Regular Fit Checked shirt Model",
                        "dataAltText": "Regular Fit Checked shirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|0827280021|Regular Fit Checked shirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "5",
                "swatches": [
                    {
                        "colorCode": "#AF9A73",
                        "articleLink": "/en_asia5/productpage.0827280021.html",
                        "colorName": "Beige/Checked"
                    },
                    {
                        "colorCode": "#9F8061",
                        "articleLink": "/en_asia5/productpage.0827280012.html",
                        "colorName": "Beige/White"
                    },
                    {
                        "colorCode": "#7EA0B6",
                        "articleLink": "/en_asia5/productpage.0827280013.html",
                        "colorName": "Light blue/White"
                    },
                    {
                        "colorCode": "#E5E0C7",
                        "articleLink": "/en_asia5/productpage.0827280016.html",
                        "colorName": "Light beige/Light grey"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1117747016",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1117747016'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTExNzc0N19ncm91cF8wMTZfZW5fYXNpYTU7MTExNzc0NzAxNl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1117747016');",
                "link": "/en_asia5/productpage.1117747016.html",
                "title": "Relaxed Fit Sweatshirt",
                "category": "men_hoodiessweatshirts_sweatshirts",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/d1/9d/d19d26a885c26b21e55df944334c03cc1db401f2.jpg],origin[dam],category[men_hoodiessweatshirts_sweatshirts],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/91/1f/911f71a55c5997abfc5d09a2e5b66abc489e2e2c.jpg],origin[dam],category[men_hoodiessweatshirts_sweatshirts],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Relaxed Fit Sweatshirt Model",
                        "dataAltText": "Relaxed Fit Sweatshirt"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1117747016|Relaxed Fit Sweatshirt|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,690",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "3",
                "swatches": [
                    {
                        "colorCode": "#F0F1F0",
                        "articleLink": "/en_asia5/productpage.1117747016.html",
                        "colorName": "White/Snoopy"
                    },
                    {
                        "colorCode": "#858C94",
                        "articleLink": "/en_asia5/productpage.1117747009.html",
                        "colorName": "Light grey marl/Snoopy"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1117747015.html",
                        "colorName": "Black/Keith Haring"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            },
            {
                "articleCode": "1019838026",
                "onClick": "setOsaParameters(utag_data.category_id,'SMALL','1019838026'); setNotificationTicket('Oy9wbHAvcHJvZHVjdC1saXN0LXdpdGgtY291bnQvcHJvZHVjdC1saXN0OyM7cHJvZHVjdF9rZXk7MTAxOTgzOF9ncm91cF8wMjZfZW5fYXNpYTU7MTAxOTgzODAyNl9lbl9hc2lhNTtPQkpFQ1RJVkUkO05PTkU6Tk9ORTs4OTs','1019838026');",
                "link": "/en_asia5/productpage.1019838026.html",
                "title": "Slim Fit Cotton chinos",
                "category": "men_trousers_chinos_slim_all",
                "image": [
                    {
                        "src": "//lp2.hm.com/hmgoepprod?set=source[/27/b7/27b7fa4187c8f2d8ebc61c1de7e0eb82d46bdd47.jpg],origin[dam],category[],type[LOOKBOOK],res[m],hmver[1]&call=url[file:/product/style]",
                        "dataAltImage": "//lp2.hm.com/hmgoepprod?set=source[/37/0e/370e4c4115dd9033987bf87992251dc1db08fc7d.jpg],origin[dam],category[men_trousers_chinos_slim_all],type[DESCRIPTIVESTILLLIFE],res[m],hmver[2]&call=url[file:/product/style]",
                        "alt": "Slim Fit Cotton chinos Model",
                        "dataAltText": "Slim Fit Cotton chinos"
                    }
                ],
                "legalText": "",
                "promotionalMarkerText": "",
                "showPromotionalClubMarker": false,
                "showPriceMarker": false,
                "favouritesTracking": "Favourites|1019838026|Slim Fit Cotton chinos|MEN_NEWARRIVALS : CLOTHING_CLOTHING : VIEWALL_VIEW_ALL",
                "favouritesSavedText": "SAVED AS FAVOURITE",
                "favouritesNotSavedText": "SAVE AS FAVOURITE",
                "marketingMarkerText": "",
                "marketingMarkerType": "",
                "marketingMarkerCss": "",
                "price": "PHP1,549",
                "redPrice": "",
                "yellowPrice": "",
                "bluePrice": "",
                "clubPriceText": "",
                "sellingAttribute": "New Arrival",
                "swatchesTotal": "7",
                "swatches": [
                    {
                        "colorCode": "#1A2840",
                        "articleLink": "/en_asia5/productpage.1019838026.html",
                        "colorName": "Dark blue"
                    },
                    {
                        "colorCode": "#272628",
                        "articleLink": "/en_asia5/productpage.1019838001.html",
                        "colorName": "Black"
                    },
                    {
                        "colorCode": "#AA9A81",
                        "articleLink": "/en_asia5/productpage.1019838002.html",
                        "colorName": "Beige"
                    },
                    {
                        "colorCode": "#383A43",
                        "articleLink": "/en_asia5/productpage.1019838003.html",
                        "colorName": "Dark blue"
                    }
                ],
                "preAccessStartDate": "",
                "preAccessEndDate": "",
                "preAccessGroups": [],
                "outOfStockText": "",
                "comingSoon": "",
                "brandName": "H&M",
                "damStyleWith": ""
            }
        ]


    export const newarrivals = [
        {
            "id": 1,
            "link": "/",
            "bannerSub": "WOMEN’S",
            "bannerText": "Dresses",
            "bannerImg": "https://images.unsplash.com/photo-1502868354157-ec2edd2a1651?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=873&q=80"
        },
        {
            "id": 2,
            "link": "/",
            "bannerSub": "WOMEN’S",
            "bannerText": "Shoes & Accessories",
            "bannerImg": "https://images.unsplash.com/photo-1523754865311-b886113bb8de?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=813&q=80"
        },
        {
            "id": 3,
            "link": "/",
            "bannerSub": "WOMEN’S",
            "bannerText": "Swimwear",
            "bannerImg": "https://images.unsplash.com/photo-1581610489912-81b6f687972d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80"
        },
        {
            "id": 4,
            "link": "/",
            "bannerSub": "MEN’S",
            "bannerText": "Sportswear",
            "bannerImg": "https://images.unsplash.com/photo-1483721310020-03333e577078?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=928&q=80"
        },
        {
            "id": 5,
            "link": "/",
            "bannerSub": "MEN’S",
            "bannerText": "Clothes",
            "bannerImg": "https://plus.unsplash.com/premium_photo-1661281366900-88b41445a004?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80"
        }
    ]

    export const deals = [
        {
            "id": 1,
            "idStyle": "img-1",
            "link": "/",
            "dealsText": "Top",
            "dealsImg": "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
            "dealsAlt": "Top"
        },
        {
            "id": 2,
            "idStyle": "img-2",
            "link": "/",
            "dealsText": "Bottom",
            "dealsImg": "https://images.unsplash.com/photo-1519707574798-77140649cfe5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1035&q=80",
            "dealsAlt": "Bottom"
        },
        {
            "id": 3,
            "idStyle": "img-3",
            "link": "/",
            "dealsText": "Accessories",
            "dealsImg": "https://images.unsplash.com/photo-1506169894395-36397e4aaee4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
            "dealsAlt": "Accessories"
        }
    ]